module.exports = __webpack_public_path__ + "img/apple_pick_ladder_sit_original.2c577f19.jpg";